export enum RequestState {
    Idle,
    Loading,
    Error,
}
